<template>
  <div :class="{ 'avue--collapse': isCollapse }" class="avue-contail">
    <div class="avue-header">
      <!-- 顶部导航栏 -->
      <top ref="top" />
    </div>
    <div class="avue-layout">
      <div class="avue-left">
        <!-- 左侧导航栏 -->
        <navigation></navigation>
      </div>
      <div class="avue-main">
        <!-- 顶部标签卡 -->
        <tags></tags>
        <!-- 主体视图层 -->
        <div id="avue-view">
          <keep-alive include="home">
            <router-view class="avue-view" rel="opener"/>
          </keep-alive>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import admin from "@/util/admin";
import {mapGetters} from "vuex";
import navigation from "./navigation/";
import top from "./top/";
import tags from "./tags";
import { Post, PostForm } from "@/util/http.js";
export default {
  name: "inDex",
  components: {
    top,
    navigation,
    tags

  },
  created() {
    if (!this.$store.state.user.token) {
      this.$router.push('/')
    }
  },
  mounted() {
    window.onresize = () => {
      setTimeout(() => {
        this.$store.commit("SET_SCREEN", admin.getScreen());
      }, 0);
    };
  },
  methods: {
    toJSON() {
    }
  },
  computed: {


    ...mapGetters(["isCollapse"])
  },
};
</script>

<style scoped>
#avue-view {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}
</style>
